// React and related imports
import React from 'react';

// Components imports
import { LogoImage } from './LogoImage';
import { LogoText } from './LogoText';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <div
      className={`flex cursor-pointer items-center ${className || ''}`}
      onClick={() => (window.location.href = '/')}
    >
      <LogoImage />
      <LogoText />
    </div>
  );
};
